export abstract class FaviconProvider {
    private static singleton: FaviconProvider;

    public static get(): FaviconProvider {
        return this.singleton;
    }

    public static set(provider: FaviconProvider) {
        this.singleton = provider;
    }

    public abstract getIconPath(key: string): string;
    public abstract get defaultFaviconPath(): string;
}
